import React, { useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { WithApp } from 'contexts/appContext';

// Import Components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import Button from 'components/CustomButtons/Button.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

//@material-ui/core
import { MenuItem, Select, FormControl, InputLabel, Checkbox, Tooltip } from '@material-ui/core';

// Modal Document Detail
import DocumentDetailModal from './Modal/DocumentModal.js';

// @material-ui/icons
import { Dashboard, Visibility, Done, AssignmentTurnedIn, Tab } from '@material-ui/icons';

import styles from 'assets/jss/material-dashboard-pro-react/views/regularFormsStyle';
import styleSweet from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { wsFindBy, wsCreate, wsUpdate } from 'services/WService';
import { currency } from 'hooks/Pipe.js';
import SweetAlert from 'react-bootstrap-sweetalert';
import CardFooter from 'components/Card/CardFooter.js';
import Badge from 'components/Badge/Badge.js';
import { useAuth } from 'hooks/useAuth.js';
import CollapseData from './CollapseResponse/CollapseData.js';
import LiquidateDocumentModal from './LiquidateDocumentModal.jsx';
import { useModal } from 'hooks/useModal';
import AmountModal from './Modal/AmountModal.js';

const useStyles = makeStyles((theme) => ({
  ...styles,
  ...styleSweet,
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  cardIconTitle: {
    color: 'black',
    fontWeight: 'bold'
  },
  marginRight: {
    float: 'right'
  },
  paper: {
    padding: theme.spacing(2),
    '& h6': {
      fontSize: 13,
      fontWeight: 'bold'
    },
    '& h5': {
      fontSize: 15,
      fontWeight: 400
    },
    marginBottom: '10px'
  },
  table: {
    width: '100%',
    minWidth: 1000,
    '& td': {
      borderTop: '1px solid #e7e7e7',
      color: 'black',
      fontWeight: '400'
    }
  }
}));

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 120 },
  { Header: 'Estado de liq.', accessor: 'state', width: 125, align: 'center' },
  { Header: 'Fec. Liqui.', accessor: 'liquidate_date', width: 100, align: 'center' },
  { Header: 'Resp', accessor: 'responsible', width: 90, align: 'center' },
  {
    Header: 'Método pago',
    accessor: 'payment_method',
    width: 145,
    align: 'center',
    excelEnabled: false,
  },
  {
    Header: 'No contado',
    accessor: 'sap_excluded',
    excelEnabled: false,
    width: 110,
    align: 'center',
  },
  { Header: 'Documento', accessor: 'document_sunat', width: 150 },
  { Header: 'Cod. Cli.', accessor: 'CardCode', width: 115 },
  { Header: 'Cliente', accessor: 'CardName' },
  { Header: 'Parcial', accessor: 'parcial', width: 90, align: 'right' },
  { Header: 'Anulado', accessor: 'anulado', width: 90, align: 'right' },
  { Header: 'Soles', accessor: 'soles', width: 90, align: 'right' },
  { Header: 'M. pagar', accessor: 'amount', width: 90, align: 'right' },
  { Header: 'M.Transf', accessor: 'TransferSum', width: 90, align: 'right' },
  { Header: 'Total', accessor: 'total', width: 90, align: 'right' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const listStatesDoc = [
  { id: 0, name: 'Completo' },
  { id: 1, name: 'Anulado' },
  { id: 2, name: 'Parcial' }
];

export default WithApp(function DistributionTracking(props) {
  const classes = useStyles();
  const { showNotify, setAlert, dataOrigin } = props;
  const reload = props.reload; //recargar data
  const reloadListDoc = props.reloadListDoc; //Recarga Lista de documentos
  const { hasPermission } = useAuth();
  const [showErrorResp, setShowErrorResp] = useState({ show: false });

  // Modal
  const [showModal, setShowModal] = useState(false);
  const [responsible, setResponsible] = useState('N');
  const [modelDocument, setOpenDocument] = useModal();

  const [processing, setProcessing] = useState(false);

  //constante temporal hasta tener la oportunidad de mejorar el performance que dejo smith. Att. clever xd
  const [showEye, setShowEye] = useState(false);

  const [idHR, setIdHR] = useState({});
  const [listDoc, setListDoc] = useState([]);
  const [listDocDetail, setListDocDetail] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState({
    ObjType: '0',
    DocEntry: '0'
  });
  const [docTotals, setDocTotals] = useState([]);
  console.log("LISTDOC: ",listDoc);
  const [stateHR, setStateHR] = useState(true);
  const [stateDoc, setStateDoc] = useState(true);
  const [actualStateDoc, setActualStateDoc] = useState(null);

  const [documentFilter, setDocumentFilter] = useState('T');
  const [amount, setAmount] = useModal();

  async function getDocDetail(
    ObjTypes,
    DocEntrys,
    bDocumentID = null,
    bDocumentState = null,
    bDocumentActualState = null,
    responsibleParam = 'N'
  ) {
    let response = await wsFindBy('prog/sheet-document-line', {
      DocEntry: DocEntrys,
      ObjType: ObjTypes
    });
    if (response.success) {
      if (bDocumentID != null && bDocumentState != null) {
        if (bDocumentState != bDocumentActualState) {
          await changeValueDoc(bDocumentID, bDocumentState, response.data, responsibleParam);
        } else {
          // Si cambio el responsable y el estado es anulado
          if(responsibleParam !== responsible && bDocumentState === 1){
            await changeValueDoc(bDocumentID, bDocumentState, response.data, responsibleParam);
          }
          setListDocDetail(response.data);
        }
      } else {
        setListDocDetail(response.data);
      }
    }
  }

  async function changeValueDoc(id, value, data, responsible = 'N') {
    let liqStatus = value == '2' || value == '0' ? '0' : '1';

    const dataDocument = listDoc.map((bData) => {
      if (bData.id == id) {
        return { ...bData, liq_status: value };
      } else {
        return bData;
      }
    });

    const dataDocDetail = data.map((bDataDetail) => {
      return {
        ...bDataDetail,
        liq_status: liqStatus,
        quantity_returned:
          value == '2' || value == '0'
            ? '0'
            : value == '1'
            ? bDataDetail.quantity_load
            : bDataDetail.quantity_returned
      };
    });

    setListDoc(dataDocument);
    setListDocDetail(dataDocDetail);
    if (value == '1' || value == '0') {
      await saveDocument(id, dataDocDetail, undefined, responsible);
    }
  }

  function changeValueDocDetail(id, campo, value) {
    const dataDocDetail = listDocDetail.map((bData) => {
      if (bData.id == id) {
        if (campo == 'state') {
          return {
            ...bData,
            liq_status: value,
            quantity_returned: value == '2' || value == '0' ? '0' : bData.quantity_load
          };
        } else {
          return {
            ...bData,
            quantity_returned:
              parseInt(value) > parseInt(bData.quantity_load)
                ? bData.quantity_load
                : parseInt(value) < 0
                ? '0'
                : value,
            liq_status:
              parseInt(value) == parseInt(bData.quantity_load)
                ? '1'
                : parseInt(value) > 0
                ? '2'
                : parseInt(value) == 0
                ? '0'
                : '2'
          };
        }
      } else {
        return bData;
      }
    });
    setListDocDetail(dataDocDetail);
  }

  /**
   * ? se comento el for que actualiza el estado de los documentos de la hoja de repartos
   * ? ya no es necesario xq al acutualizar la lineas tambien se actualiza el estado del documento
   */
  async function liquidationDocuments(idHR) {
    let response = await wsCreate(`prog/sheet-distribution/${idHR}/liquidate`);

    if (response.success) {
      showNotify(response.message);
      reload();
      setStateHR(false);
      props.setSelectedHR(response.data);
      setStateDoc(false);
    } else {
      if (response.message.includes('400')) {
        setShowErrorResp({ show: true, data: response.data });
        showNotify(response.message, 'error');
        return;
      }
      setShowErrorResp({ show: false });
      showNotify(response.message, 'error');
    }
  }

  /**
   * @param {id del documento} idDoc
   * @param {detalles del documento} dataDocDetail
   * @param {funcion para realizar una accion dependiente del response} actionModal
   */
  async function saveDocument(idDoc, dataDocDetail, actionModal = undefined, responsible = 'N') {
    let newData = dataDocDetail.map((item) => {
      return {
        id: item.id,
        quantity_returned: item.quantity_returned,
        liq_status: item.liq_status
      };
    });
    let response = await wsUpdate(`prog/sheet-document/${idDoc}/liquidate`, {
      lines: newData,
      responsible,
    });
    setResponsible('N');
    if (response.success) {
      showNotify(response.message);
      reloadListDoc(idHR);
      setShowModal(false);
    } else {
      if (response.message.includes('400')) {
        if (actionModal) actionModal(false, response.data);
        showNotify(response.message, 'error');
        return;
      }
      if (actionModal) actionModal(true);
      showNotify(response.message, 'error');
    }
  }

  //#region   confirmar antes de realizar la acción
  async function confirmChangeStateLiquid(bDocument, bListDoc, responsible = 'N') {
    setSelectedDoc(bDocument);
    setActualStateDoc(bListDoc.id);
    if (bDocument.DocEntry) {
      await getDocDetail(
        bDocument.ObjType,
        bDocument.DocEntry,
        bDocument.id,
        bListDoc.id,
        bDocument.liq_status,
        responsible,
      );
    }
    setStateDoc(bListDoc.id == '2' ? true : false);
    setShowModal(bListDoc.id == '2' ? true : false);
    setResponsible(responsible);
  }

  const hideAlert = () => {
    setAlert(undefined);
  };

  function confirm(param1, param2, liquidation = false) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Está seguro de realizar esta acción?"
        onConfirm={() => {
          confirmChangeStateLiquid(param1, param2);
          if (liquidation) liquidationDocuments(param1);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }
  //#endregion

  function calcTotals(arr) {
    let parcial = 0;
    let anulado = 0;
    let soles = 0;
    let amount = 0;
    let TransferSum = 0;
    let total = arr.reduce((total, document) => total + parseFloat(document.total || 0), 0);

    arr = arr.filter(filterDocument);

    const excludedDocs = arr.filter((document) => document.sap_excluded === 'Y');

    // No contado (sea contado o crédito): solo suma su concepto, si el check de concepto está activo
    const conceptSum = excludedDocs.reduce((acc, document) => {
      const hasConcept = document.advance_payment === 'Y' && (document.liq_status === '0' || document.liq_status === '2');
      return acc + (hasConcept ? parseFloat(document.SumApplied || 0) : 0);
    }, 0);

    for (let obj of arr) {
      parcial += parseFloat(obj.parcial || 0);
      if (obj.sap_excluded === 'N') {
        anulado += parseFloat(obj.anulado || 0);
        soles += parseFloat(obj.soles || 0);
        // El crédito sin No contado no suma: la vista lo manda con monto_pagar en 0
        amount += parseFloat(obj.monto_pagar || 0);
        TransferSum += parseFloat(obj.TransferSum || 0);
      }
    }

    const totalSoles = soles + conceptSum;
    const totalAmount = amount + conceptSum;

    setDocTotals([
      {
        total_documents: arr.length,
        documents_excludes: excludedDocs.length,
        parcial: parcial.toFixed(2),
        anulado: anulado.toFixed(2),
        soles: totalSoles.toFixed(2),
        amount: totalAmount.toFixed(2),
        TransferSum: TransferSum.toFixed(2),
        total: total.toFixed(2),
      },
    ]);
  }

  async function toggleDocumentExcluded(document) {
    const response = await wsUpdate('prog/sheet-document', document.id, {
      sap_excluded: document.sap_excluded === 'Y' ? 'N' : 'Y'
    });
    if (!response.success) showNotify(response.message, 'error');
    return response.success;
  }

  const filterColumns = () => {
    let dataColumns = columns;
    if (
      !hasPermission(ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_DOCUMENT_EXCLUDED)
    ) {
      dataColumns = columns.filter((item) => !item.accessor.includes(['sap_excluded']));
    }
    return dataColumns;
  };

  // Seteo de DATA y STATE de HR, DOC Y DocDetail
  useEffect(() => {
    setIdHR(props.dataHR.id);
    setStateHR(
      props.dataHR.state == 'N' ||
        props.dataHR.state == 'W' ||
        props.dataHR.state == '1' ||
        props.dataHR.state == '2' ||
        props.dataHR.state == '3' ||
        props.dataHR.state == '4'
        ? true
        : false
    );
    setShowErrorResp({ show: false });
  }, [props.dataHR]);

  useEffect(() => {
    setListDoc(props.dataDetail);
    calcTotals(props.dataDetail);
  }, [props.dataDetail, listDoc]);

  useEffect(() => {
    calcTotals(props.dataDetail);
  }, [documentFilter]);

  function filterDocument(bDocument) {
    if (documentFilter === 'T') {
      return true;
    }
    return bDocument.liq_status === documentFilter;
  }

  async function updateDocumentPayment(bDocument, payment_method) {
    if (!stateHR) return;
    if (processing) return;

    let res = await wsUpdate('prog/sheet-document', bDocument.id, {
      payment_method,
    });

    if (res.success) {
      setListDoc((documents) => {
        let newDocuments = [...documents];
        let index = newDocuments.findIndex((document) => bDocument.id === document.id);
        newDocuments[index].payment_method = payment_method;
        return newDocuments;
      });
    }

  }

  return (
    <>
      <LiquidateDocumentModal
        model={modelDocument}
        setOpen={setOpenDocument}
        showNotify={showNotify}
        confirmChangeStateLiquid={confirmChangeStateLiquid}
      />
      <AmountModal dataOrigin={dataOrigin} model={amount} setOpen={setAmount} reload={() => reloadListDoc(idHR)} showNotify={showNotify} setAlert={setAlert} hideAlert={hideAlert} classes={classes}/>
      {showModal ? (
        <DocumentDetailModal
          closeModal={setShowModal}
          open={showModal}
          saveDocument={saveDocument}
          selectedDoc={selectedDoc}
          listDocDetail={listDocDetail}
          stateHR={stateHR}
          changeValueDocDetail={changeValueDocDetail}
          listStatesDoc={listStatesDoc}
          actualStateDoc={actualStateDoc}
          stateDoc={stateDoc}
          showEye={showEye}
          setShowEye={setShowEye}
          listDoc={listDoc}
          setListDoc={setListDoc}
          responsible={responsible}
        />
      ) : undefined}

      {showErrorResp.show ? (
        <CollapseData
          title="Mostrar documentos a retirar del documento"
          close={() => setShowErrorResp({ show: false })}
        >
          <ErrorResponse data={showErrorResp.data} />
        </CollapseData>
      ) : undefined}

      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Dashboard />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Documentos</h4>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem sm={4} lg={3} xl={2}>
              <FormControl fullWidth>
                {/* <InputLabel>Filtro estado</InputLabel> */}
                <Select onChange={(e) => setDocumentFilter(e.target.value)} value={documentFilter}>
                  <MenuItem value="T">Todos</MenuItem>
                  <MenuItem value="0">Completo</MenuItem>
                  <MenuItem value="2">Parcial</MenuItem>
                  <MenuItem value="1">Anulado</MenuItem>
                </Select>
              </FormControl>
            </GridItem>
            <GridItem sm={8} lg={9} xl={10}>
              <AllowedGuard
                permission={ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_LIQUIDATE}
              >
                <Button
                  color="success"
                  round
                  size="sm"
                  className={classes.marginRight}
                  onClick={() => confirm(idHR, listDoc, true)}
                  disabled={!stateHR}
                >
                  {stateHR ? (
                    <Done className={classes.icons} />
                  ) : (
                    <AssignmentTurnedIn className={classes.icons} />
                  )}
                  {stateHR ? 'Liquidar' : 'Liquidado'}
                </Button>
              </AllowedGuard>
            </GridItem>
          </GridContainer>
          <ReactTable
            exportExcel={!stateHR}
            formatDate="DD-MM-YYYY"
            excelName="Documentos-de-hoja-reparto"
            defaultWidth={1700}
            colorRow={(item) => {
              return item.GroupNum != '-1' ? '#ff000036' : '';
            }}
            columns={filterColumns()}
            data={listDoc.filter(filterDocument).map((bDocument, index) => {
              const data = {
                num: (
                  <div>
                    <AllowedGuard
                      permission={
                        ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_DOCUMENT_SHOW_LIQUIDATED
                      }
                    >
                      <Button
                        justIcon
                        round
                        simple
                        color="primary"
                        className="like"
                        onClick={() => {
                          setActualStateDoc(bDocument.liq_status);
                          setSelectedDoc(bDocument);
                          getDocDetail(bDocument.ObjType, bDocument.DocEntry);
                          setStateDoc(false);
                          setShowModal(true);
                          setShowEye(true);
                        }}
                      >
                        <Visibility />
                      </Button>
                    </AllowedGuard>
                    <Tooltip title={bDocument.PymntGroup}>
                      <span
                        style={{
                          background: '#9c27b0',
                          padding: '1px 2px',
                          borderRadius: '30px',
                          color: 'white',
                          cursor: 'pointer',
                          fontSize: '13px',
                        }}
                      >
                        {bDocument.id}
                      </span>
                    </Tooltip>
                  </div>
                ),
                state: stateHR ? (
                  <AllowedGuard
                    permission={
                      ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_DOCUMENT_CHANGE_STATE
                    }
                    component={
                      listStatesDoc[
                        listStatesDoc.findIndex((obj) => obj.id == bDocument.liq_status)
                      ].name
                    }
                  >
                    <Select
                      fullWidth={true}
                      MenuProps={{
                        className: classes.selectMenu,
                      }}
                      value={bDocument.liq_status || '0'}
                    >
                      {listStatesDoc.map((bListDoc, i) => {
                        return (
                          <MenuItem
                            key={i}
                            value={bListDoc.id}
                            onClick={() => {
                              // Anulado
                              if (bListDoc.id === 1 || bListDoc.id === 2) {
                                setOpenDocument({
                                  document: { ...bDocument, open: true },
                                  liqStatus: bListDoc,
                                  liquidate: false,
                                });
                              } else {
                                confirm(bDocument, bListDoc);
                              }
                            }}
                          >
                            {bListDoc.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </AllowedGuard>
                ) : bDocument.liq_status == '' ||
                  bDocument.liq_status == null ||
                  bDocument.liq_status == '-1' ? (
                  '-'
                ) : (
                  listStatesDoc[listStatesDoc.findIndex((obj) => obj.id == bDocument.liq_status)]
                    .name
                ),
                liquidate_date: bDocument.liquidate_date,
                responsible: bDocument.responsible === 'N' ? 'Normal' : 'Vendedor',
                payment_method: (
                  <FormControl fullWidth margin="normal" size="small">
                    <Select
                      disabled={!stateHR || processing}
                      value={bDocument.payment_method || 'CASH'}
                    >
                      <MenuItem
                        value="CASH"
                        onClick={() => {
                          updateDocumentPayment(bDocument, 'CASH');
                        }}
                      >
                        Efectivo
                      </MenuItem>
                      <MenuItem
                        value="TRANSFER"
                        onClick={() => {
                          updateDocumentPayment(bDocument, 'TRANSFER');
                        }}
                      >
                        Transferencia
                      </MenuItem>
                    </Select>
                  </FormControl>
                ),
                sap_excluded: (
                  <>
                    <Checkbox
                      checked={bDocument.sap_excluded === 'Y'}
                      disabled={!stateHR}
                      onClick={async () => {
                        // solo se marca si el ws lo aceptó (anulado y no contado no van juntos)
                        if (!(await toggleDocumentExcluded(bDocument))) return;
                        let newList = [...listDoc];
                        newList[index].sap_excluded = bDocument.sap_excluded === 'Y' ? 'N' : 'Y';
                        setListDoc(newList);
                      }}
                    />
                    {bDocument.sap_excluded === 'Y' && (
                      // <a
                      //   target="__blank"
                      //   href={`/admin/bancos/operaciones/pago-recibidos/${bDocument.base_business_partner_id}?state4=1`}
                      // >
                      //   <Button color="warning" justIcon round simple>
                      //     <Tab />
                      //   </Button>
                      // </a>
                      <Button
                        justIcon
                        round
                        color="info"
                        size="sm"
                        onClick={() => {
                          setAmount(bDocument);
                        }}
                      >
                        <Tab />
                      </Button>
                    )}
                  </>
                ),
                document_sunat: bDocument.document_sunat,
                CardCode: bDocument.CardCode,
                CardName: bDocument.CardName,
                parcial: currency(bDocument.parcial),
                anulado: currency(bDocument.anulado),
                soles: 
                  bDocument.sap_excluded === 'Y' ?
                    bDocument.advance_payment !== 'Y' ? '0' : (bDocument.liq_status === '0' || bDocument.liq_status === '2') ? currency(bDocument.SumApplied) :  0
                  : currency(bDocument.soles),
                amount: 
                  bDocument.sap_excluded === 'Y' ?
                    bDocument.advance_payment !== 'Y' ? '0' : (bDocument.liq_status === '0' || bDocument.liq_status === '2') ? currency(bDocument.SumApplied) :  0
                  : currency(bDocument.monto_pagar),
                TransferSum:
                  bDocument.TransferSum === null ? currency(0) : currency(bDocument.TransferSum),
                total: currency(bDocument.total),
                actions: '',
                GroupNum: bDocument.GroupNum,
              };
              if (
                !hasPermission(
                  ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_DOCUMENT_EXCLUDED,
                )
              ) {
                delete data.sap_excluded;
              }
              return data;
            })}
          />
        </CardBody>
        <CardFooter style={{ display: 'block' }}>
          <ReactTable
            pagination={false}
            showHeader={false}
            exportExcel={false}
            defaultWidth={1700}
            columns={[
              { Header: 'Cliente', accessor: 'CardName', width: 1000, align: 'right' },
              { Header: 'Parcial', accessor: 'parcial', width: 100, align: 'right' },
              { Header: 'Anulado', accessor: 'anulado', width: 100, align: 'right' },
              { Header: 'Soles', accessor: 'soles', width: 100, align: 'right' },
              { Header: 'M. pagar', accessor: 'amount', width: 100, align: 'right' },
              { Header: 'M.Transf', accessor: 'TransferSum', width: 100, align: 'right' },
              { Header: 'Total', accessor: 'total', width: 100, align: 'right' },
              { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
            ]}
            data={docTotals.map((item) => {
              return {
                CardName: `${item.documents_excludes} documentos excluidos de ${item.total_documents}`,
                parcial: <b>{currency(item.parcial)}</b>,
                anulado: <b>{currency(item.anulado)}</b>,
                soles: <b>{currency(item.soles)}</b>,
                amount: <b>{currency(item.amount)}</b>,
                TransferSum: <b>{currency(item.TransferSum)}</b>,
                total: <b>{currency(item.total)}</b>,
                actions: '',
              };
            })}
          />
        </CardFooter>
      </Card>
    </>
  );
});

const ErrorResponse = ({ data }) => {
  const classes = useStyles();
  return (
    <table className={classes.table}>
      <thead>
        <tr>
          <th>N° HR</th>
          <th>Documento</th>
          <th>Cliente</th>
          <th>Total</th>
          <th>Total Doc.</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, i) => (
          <tr key={i}>
            <td align="center">{item.prog_sheet_distribution_id}</td>
            <td align="center">{item.document_sunat}</td>
            <td align="center">
              {item.CardCode} - {item.CardName}
            </td>
            <td align="right">{currency(item.DocTotal)}</td>
            <td align="right">{currency(item.SumApplied)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
